
import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { DomainService } from './domain.service';
import { CartService } from './cart.service';

export type TapSource = 'all' | 'knet';

@Injectable({ providedIn: 'root' })
export class TapRedirectPaymentsService {
  constructor(
    private api: ApiService,
    private domain: DomainService,
    private cartService: CartService,
  ) { }

  startRedirect(orderIds: string[], source: TapSource): void {
    this.api.createTapRedirect({
      subdomain: this.domain.getSubdomain(),
      order_ids: orderIds,
      payment_source: source,
    })
      .subscribe((res) => {
        const url = res.url;
        if (!url) {
          console.error('[Tap] No redirect URL from backend response', res);
          return;
        }
        // Cart clears later, once payment is confirmed (socket event or on-load reconciliation).
        this.cartService.setPendingPayment(orderIds);
        window.location.assign(url);
      }, (err) => {
        console.error('[Tap] createTapRedirect failed', err);
      });
  }
}
